import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Company } from '../contracts/company.interface';
import { Contact } from '../contracts/contact.interface';

@Injectable({ providedIn: 'root' })
export class CompanyService {
  private baseUrl = 'companies';

  constructor(private http: HttpClient) {}

  getAll(page = 1, size = 100): Observable<{ data: Company[]; total: number }> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<{ data: Company[]; total: number }>(this.baseUrl, { params });
  }

  getById(id: number): Observable<Company> {
    return this.http.get<Company>(`${this.baseUrl}/${id}`);
  }

  create(company: Partial<Company>): Observable<Company> {
    return this.http.post<Company>(this.baseUrl, company);
  }

  update(id: number, company: Partial<Company>): Observable<Company> {
    return this.http.put<Company>(`${this.baseUrl}/${id}`, company);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getContacts(id: number): Observable<Contact[]> {
    return this.http.get<Contact[]>(`${this.baseUrl}/${id}/contacts`);
  }
}
